module.exports = __webpack_public_path__ + "assets/img/2018_6.29d021dc.png";